import aiIcon from "../icons/focus-1.svg";
import iotIcon from "../icons/focus-2.svg";
import cyberIcon from "../icons/focus-3.svg";
import dataIcon from "../icons/focus-4.svg";
import cloudIcon from "../icons/focus1-1.svg";
import embeddedIcon from "../icons/focus1-2.svg";
import visionIcon from "../icons/focus1-3.svg";

import { useInternationalizedItems } from "../custom-hooks/useInternationalizedItems";
import { CardSize } from "../types/constants";
import { isCardLarge } from "../utils/helpers";
import { useBreakpoint } from "../custom-hooks/useBreakpoint"; // 👈 підключаємо твій хук

type DirectionFeatureItem = {
    title: string;
    description: string;
    icon: string;
    size?: CardSize;
};

const iconMap: Record<string, string> = {
    "focus-1": aiIcon,
    "focus-2": iotIcon,
    "focus-3": cyberIcon,
    "focus-4": dataIcon,
    "focus1-1": cloudIcon,
    "focus1-2": embeddedIcon,
    "focus1-3": visionIcon,
};

export default function DirectionsFeatureBlock() {
    const { isTablet, isDesktopSmall } = useBreakpoint();
    let items = useInternationalizedItems<DirectionFeatureItem[]>({
        key: "home.directionsFeatureItems",
    });

    // логіка для 768–1279px (tablet + desktopSmall)
    if (isTablet || isDesktopSmall) {
        const largeCards = items.filter((i) => isCardLarge(i.size));
        const smallCards = items.filter((i) => !isCardLarge(i.size));

        const reordered: DirectionFeatureItem[] = [];
        for (let i = 0; i < largeCards.length; i++) {
            reordered.push(largeCards[i]);
            reordered.push(...smallCards.splice(0, 2));
        }
        items = reordered;
    }

    return (
        <div className="w-full max-w-[1280px] mt-6 flex flex-col gap-2 md:grid md:grid-cols-2 md:gap-2 xl:flex xl:flex-wrap xl:flex-row xl:gap-5">
            {items.map((item, index) => {
                const large = isCardLarge(item.size);

                const widthClasses = large
                    ? "w-full md:col-span-2 xl:w-[380px] lg:w-[413px]"
                    : "w-full md:w-full xl:w-[280px] lg:w-[305px]";

                const textWidthClasses = large ? "md:w-full xl:w-[340px] lg:w-[373px]" : "xl:w-[260px] lg:w-[265px]";

                return (
                    <div
                        key={index}
                        className={`bg-background-100 border border-border-400 shadow-[0_4px_4px_0_#36335214] rounded-[6px]
              flex flex-row items-center gap-2 px-4 py-4 text-left md:flex-col md:text-center xl:h-[233px] ${widthClasses} lg:gap-4 lg:px-5 lg:py-5`}
                    >
                        <div className="w-[60px] h-[60px] flex items-center justify-center flex-shrink-0">
                            <img
                                src={iconMap[item.icon]}
                                alt={item.title}
                                className="w-[44px] h-[44px] lg:w-[46px] lg:h-[50px]"
                            />
                        </div>

                        <div
                            className={`flex flex-col justify-center gap-2 w-[270px] h-[92px] ${textWidthClasses} lg:w-auto lg:h-auto`}
                        >
                            <h4 className="font-medium text-text-700 text-base">{item.title}</h4>
                            <p className="font-normal text-text-300 text-base">{item.description}</p>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
